import { gql } from '@apollo/client';

export const GET_MY_CB_SUBSCRIPTION = gql`
  query GetMyCbSubscription($input: GetMyCbSubscriptionInput!) {
    getMyCbSubscription(input: $input) {
      billingCycleAnchor
      cancelAt
      cancelAtPeriodEnd
      canceledAt
      currentPeriodEnd
      currentPeriodStart
      defaultBillingAddressCopy {
        email
      }
      defaultBillingAddressId
      defaultPaymentMethod {
        id
      }
      billingCycleAnchor
      canceledAt
      startDate
      downgradeScheduleMeta {
        items {
          priceId
          quantity
          price {
            product {
              name
            }
          }
        }
      }
      downgradeStartAt
      id
      items {
        currentPeriodEnd
        currentPeriodStart
        id
        price {
          active
          billingScheme
          createdAt
          displayedDiscount
          id
          isPublic
          lastSyncedAt
          monthlyEquivalentPrice
          name
          product {
            createdAt
            description
            id
            isMostPopular
            lastSyncedAt
            marketingFeatures
            name
            orderIndex
            subType
          }
          recurringInterval
          recurringIntervalCount
          subType
          type
          unitAmount
          usageType
        }
        quantity
        unitAmount
      }
      lastPaymentFailedAt
      startDate
      status
      trialEnd
      trialStart
      type
    }
  }
`;

export const GET_CB_PLANS = gql`
  query GetCbPlans {
    getCbPlans {
      id
      description
      isMostPopular
      marketingFeatures
      name
      orderIndex
      prices {
        id
        type
        active
        billingScheme
        displayedDiscount
        id
        isPublic
        monthlyEquivalentPrice
        name
        recurringInterval
        unitAmount
      }
      subType
      type
    }
  }
`;

export const GET_AGENCY = gql`
  query GetAgency($input: GetAgencyInput!) {
    getAgency(input: $input) {
      id
      stripeCustomerUrl
    }
  }
`;

export const GET_MY_ENTITLEMENTS = gql`
  query GetMyEntitlements($input: GetMyCbEntitlementsInput!) {
    getMyEntitlements(input: $input) {
      __typename
      id
      status
      validUntil
      type
      ... on CbTalentBookingResearchEntitlement {
        credits
      }
      ... on CbTeamEntitlement {
        seats
      }
    }
  }
`;

export const GET_MY_INVOICES = gql`
  query GetMyInvoices($input: GetMyInvoicesInput!) {
    getMyInvoices(input: $input) {
      entities {
        id
        total
        subtotal
        paidAt
        status
        type
        invoicePdfUrl
      }
      total
      limit
      offset
    }
  }
`;
